import React, { useState } from 'react';
import MainLayout from '../layouts/MainLayout';
import { Card, CardContent } from '../components/Card';
import { ChevronDown, MessageCircle, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqCategories = [
    {
      category: 'Allgemeine Fragen',
      questions: [
        {
          question: 'Welche Dienstleistungen bietet SENKAY an?',
          answer: 'SENKAY bietet umfassende Personal- und Logistikdienstleistungen an, darunter Arbeitnehmerüberlassung, Gebäudemanagement, Event-Aufbau, Abbrucharbeiten, Bauendreinigung, Stadtarbeiten und Eventpersonal. Wir decken alle Branchen ab und bieten maßgeschneiderte Lösungen für Ihren individuellen Bedarf.'
        },
        {
          question: 'In welchen Regionen sind Sie tätig?',
          answer: 'Wir sind primär in München und Bayern tätig, bedienen aber auch Kunden in der gesamten DACH-Region (Deutschland, Österreich, Schweiz). Für größere Projekte können wir bundesweit Personal bereitstellen.'
        },
        {
          question: 'Wie schnell können Sie Personal bereitstellen?',
          answer: 'Bei akutem Bedarf können wir oft innerhalb von 24-48 Stunden qualifiziertes Personal bereitstellen. Für planbare Einsätze empfehlen wir eine Vorlaufzeit von mindestens einer Woche, um die optimale Personalauswahl sicherzustellen.'
        },
        {
          question: 'Was unterscheidet SENKAY von anderen Personaldienstleistern?',
          answer: 'Unsere Stärken liegen in der persönlichen Betreuung, schnellen Verfügbarkeit, geprüften Mitarbeitern und vollständiger Rechts- und Versicherungssicherheit. Wir bieten einen zentralen Ansprechpartner für alle Belange und sorgen für kontinuierliche Qualitätssicherung.'
        }
      ]
    },
    {
      category: 'Arbeitnehmerüberlassung',
      questions: [
        {
          question: 'Was ist Arbeitnehmerüberlassung?',
          answer: 'Bei der Arbeitnehmerüberlassung (auch Zeitarbeit oder Leiharbeit genannt) stellen wir Ihnen Arbeitnehmer zur Verfügung, die arbeitsrechtlich bei uns angestellt sind. Sie erhalten das Weisungsrecht für die Dauer des Einsatzes. Wir übernehmen alle administrativen und rechtlichen Aufgaben.'
        },
        {
          question: 'Wie lange darf ein Leiharbeitnehmer bei uns eingesetzt werden?',
          answer: 'Die gesetzliche Überlassungshöchstdauer beträgt 18 aufeinanderfolgende Monate an denselben Entleiher. Es gibt jedoch tarifvertragliche Ausnahmen. Nach 9 Monaten greift das Equal-Pay-Prinzip, sofern keine abweichenden Tarifverträge gelten.'
        },
        {
          question: 'Was bedeutet Equal Pay?',
          answer: 'Equal Pay bedeutet gleiches Entgelt für Leiharbeitnehmer wie für vergleichbare Stammmitarbeiter des Entleihers. Dies gilt ab dem 10. Einsatzmonat beim selben Entleiher, sofern keine tarifvertraglichen Abweichungen vereinbart wurden.'
        },
        {
          question: 'Welche Qualifikationen haben Ihre Leiharbeitnehmer?',
          answer: 'Wir vermitteln sowohl qualifizierte Fachkräfte als auch Helfer für alle Branchen. Alle Mitarbeiter werden vor dem Einsatz geprüft, und erforderliche Zertifikate werden validiert. Bei spezifischen Anforderungen führen wir gezielte Schulungen durch.'
        },
        {
          question: 'Was passiert, wenn ein Mitarbeiter ausfällt?',
          answer: 'Bei Krankheit oder anderen Ausfällen stellen wir schnellstmöglich einen gleichwertigen Ersatz. Wir informieren Sie umgehend und koordinieren den Austausch so, dass Ihre Abläufe minimal beeinträchtigt werden.'
        }
      ]
    },
    {
      category: 'Kosten & Abrechnung',
      questions: [
        {
          question: 'Wie berechnen sich die Kosten?',
          answer: 'Die Kosten richten sich nach Qualifikation, Einsatzdauer und Tätigkeitsbereich. Wir erstellen Ihnen ein transparentes Angebot basierend auf Ihren spezifischen Anforderungen. Alle Preise verstehen sich inklusive Sozialversicherung, Versicherungen und administrativer Aufwände.'
        },
        {
          question: 'Welche Zahlungsbedingungen gelten?',
          answer: 'Unsere Standardzahlungsfrist beträgt 14 Tage nach Rechnungsdatum. Bei langfristigen Kooperationen können individuelle Zahlungsziele vereinbart werden. Wir akzeptieren Überweisung, SEPA-Lastschrift und weitere Zahlungsmethoden nach Absprache.'
        },
        {
          question: 'Gibt es versteckte Kosten?',
          answer: 'Nein. Wir legen großen Wert auf Transparenz. Alle Kosten werden im Vorfeld klar kommuniziert. Zusätzliche Leistungen (z.B. Sonderschichten, besondere Qualifikationen) werden separat ausgewiesen und nur nach Ihrer Zustimmung berechnet.'
        },
        {
          question: 'Kann ich ein individuelles Angebot anfordern?',
          answer: 'Ja, gerne! Nutzen Sie unser Kontaktformular oder rufen Sie uns direkt an. Nach einer kurzen Bedarfsanalyse erstellen wir Ihnen ein maßgeschneidertes, unverbindliches Angebot innerhalb von 24 Stunden.'
        }
      ]
    },
    {
      category: 'Rechtliches & Compliance',
      questions: [
        {
          question: 'Verfügt SENKAY über die erforderlichen Erlaubnisse?',
          answer: 'Ja, SENKAY verfügt über die gesetzlich vorgeschriebene Erlaubnis zur Arbeitnehmerüberlassung gemäß § 1 AÜG. Alle erforderlichen Zertifizierungen und Nachweise können auf Anfrage bereitgestellt werden.'
        },
        {
          question: 'Wer haftet bei Arbeitsunfällen?',
          answer: 'Während des Einsatzes beim Kunden liegt die Verantwortung für Arbeitssicherheit beim Entleiher. Unsere Mitarbeiter sind vollständig versichert (Unfall-, Haftpflicht-, Sozialversicherung). Wir arbeiten eng mit Ihnen zusammen, um alle Sicherheitsvorschriften einzuhalten.'
        },
        {
          question: 'Wie wird der Datenschutz gewährleistet?',
          answer: 'Wir sind DSGVO-konform und behandeln alle personenbezogenen Daten mit höchster Vertraulichkeit. Mitarbeiterdaten werden nur im erforderlichen Umfang verarbeitet und nach gesetzlichen Aufbewahrungsfristen gelöscht. Weitere Details finden Sie in unserer Datenschutzerklärung.'
        },
        {
          question: 'Was sind A1-Bescheinigungen und warum sind sie wichtig?',
          answer: 'A1-Bescheinigungen bestätigen, dass Sozialversicherungsbeiträge im Heimatland des Arbeitnehmers entrichtet werden. Sie sind bei grenzüberschreitenden Einsätzen innerhalb der EU erforderlich. SENKAY stellt alle notwendigen A1-Bescheinigungen bereit und gewährleistet volle Compliance.'
        }
      ]
    },
    {
      category: 'Ablauf & Prozess',
      questions: [
        {
          question: 'Wie läuft die Zusammenarbeit ab?',
          answer: 'Der Prozess umfasst vier Schritte: (1) Anfrage & Bedarfsanalyse - Sie kontaktieren uns mit Ihrem Bedarf. (2) Angebot & Planung - Wir erstellen ein transparentes Angebot und planen die Details. (3) Personaleinsatz - Unsere qualifizierten Mitarbeiter starten den Einsatz. (4) Abrechnung & Feedback - Nach Abschluss erfolgt die transparente Abrechnung.'
        },
        {
          question: 'Kann ich die Mitarbeiter vorab kennenlernen?',
          answer: 'Ja, bei längerfristigen Einsätzen empfehlen wir Kennenlern-Gespräche oder Probearbeiten. So können Sie sicherstellen, dass die Chemie stimmt und die Qualifikationen Ihren Erwartungen entsprechen.'
        },
        {
          question: 'Was passiert, wenn ich mit einem Mitarbeiter nicht zufrieden bin?',
          answer: 'Bitte informieren Sie uns umgehend bei Unzufriedenheit. Wir nehmen Ihr Feedback ernst und werden entweder mit dem Mitarbeiter Verbesserungen besprechen oder zeitnah einen Ersatz stellen. Ihre Zufriedenheit ist unser oberstes Ziel.'
        },
        {
          question: 'Kann ich Mitarbeiter nach dem Einsatz direkt übernehmen?',
          answer: 'Ja, bei Direkteinstellung eines überlassenen Arbeitnehmers während oder innerhalb von 12 Monaten nach Beendigung der Überlassung fällt eine Vermittlungsprovision an. Details dazu finden Sie in unseren AGB. Wir unterstützen Sie gerne bei der Übernahme.'
        }
      ]
    },
    {
      category: 'Services & Leistungen',
      questions: [
        {
          question: 'Welche Branchen bedienen Sie?',
          answer: 'Wir bedienen alle Branchen: Produktion, Logistik, Handel, Handwerk, Dienstleistung, Immobilien, Events, Bau, öffentlicher Dienst und mehr. Unsere Mitarbeiter sind branchenübergreifend qualifiziert und anpassungsfähig.'
        },
        {
          question: 'Bieten Sie auch kurzfristige Event-Unterstützung?',
          answer: 'Ja, wir sind auf Event-Logistik spezialisiert: Messe-Auf- und Abbau, Konzertbühnen, Theaterkulissen, Bestuhlung und mehr. Auch bei kurzfristigen Anfragen können wir oft helfen. Wir bieten 24/7 Verfügbarkeit für dringende Event-Projekte.'
        },
        {
          question: 'Was umfasst Ihr Gebäudemanagement?',
          answer: 'Unser Gebäudemanagement beinhaltet technisches, infrastrukturelles und kaufmännisches Facility Management. Dazu gehören Wartung, Instandhaltung, Objektbetreuung, Energiemanagement und vieles mehr. Wir sind Ihr zentraler Ansprechpartner für alle Immobilienbelange.'
        },
        {
          question: 'Führen Sie auch Reinigungsarbeiten durch?',
          answer: 'Ja, wir bieten Bauendreinigung, Unterhaltsreinigung und Spezialreinigungen an. Unsere Teams arbeiten nach höchsten Qualitätsstandards und nutzen professionelle Reinigungstechnik. Für wiederkehrende Reinigungsleistungen erstellen wir individuelle Service-Pakete.'
        }
      ]
    }
  ];

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const index = `${categoryIndex}-${questionIndex}`;
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <MainLayout
      title="Häufig gestellte Fragen (FAQ) | SENKAY Personal & Logistik"
      description="Antworten auf die häufigsten Fragen zu unseren Personaldienstleistungen, Arbeitnehmerüberlassung und Logistiklösungen."
    >
      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-24 pb-12 bg-gradient-to-b from-primary-skin/30 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <MessageCircle className="w-16 h-16 mx-auto mb-6 text-primary-blue-mid" />
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-text-dark mb-6">
            Häufig gestellte Fragen
          </h1>
          <p className="text-lg md:text-xl text-primary-text-muted leading-relaxed">
            Hier finden Sie Antworten auf die wichtigsten Fragen zu unseren Dienstleistungen.
            Sollte Ihre Frage nicht dabei sein, kontaktieren Sie uns gerne direkt.
          </p>
        </div>
      </section>

      {/* FAQ Categories */}
      {faqCategories.map((category, categoryIndex) => (
        <section key={categoryIndex} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h2 className="text-2xl md:text-3xl font-bold text-primary-text-dark mb-6">
            {category.category}
          </h2>

          <div className="space-y-4">
            {category.questions.map((faq, questionIndex) => {
              const index = `${categoryIndex}-${questionIndex}`;
              const isOpen = openIndex === index;

              return (
                <Card key={questionIndex} hover={false}>
                  <CardContent className="p-0">
                    <button
                      onClick={() => toggleQuestion(categoryIndex, questionIndex)}
                      className="w-full text-left p-6 flex items-center justify-between hover:bg-primary-gray-light transition-colors rounded-xl"
                    >
                      <h3 className="text-lg font-semibold text-primary-text-dark pr-4">
                        {faq.question}
                      </h3>
                      <ChevronDown
                        className={`w-6 h-6 text-primary-blue-mid flex-shrink-0 transition-transform duration-300 ${
                          isOpen ? 'rotate-180' : ''
                        }`}
                      />
                    </button>

                    {isOpen && (
                      <div className="px-6 pb-6">
                        <div className="pt-4 border-t border-primary-gray-border">
                          <p className="text-primary-text-muted leading-relaxed">
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    )}
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </section>
      ))}

      {/* Contact CTA */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Card>
          <CardContent className="text-center p-8 md:p-12">
            <h2 className="text-2xl md:text-3xl font-bold text-primary-text-dark mb-4">
              Ihre Frage war nicht dabei?
            </h2>
            <p className="text-primary-text-muted mb-8 max-w-2xl mx-auto">
              Unser Team steht Ihnen gerne für weitere Fragen zur Verfügung. Kontaktieren Sie uns
              telefonisch oder über unser Kontaktformular.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/kontakt">
                <Button variant="primary" size="lg">
                  Kontaktformular
                </Button>
              </Link>
              <a href="tel:+4917762766603">
                <Button variant="secondary" size="lg" icon={Phone}>
                  +49 177 6276603
                </Button>
              </a>
            </div>
          </CardContent>
        </Card>
      </section>
    </MainLayout>
  );
};

export default FAQPage;
